import type { IconSvgObject } from './types';

const FolderUnlockedIcon: IconSvgObject = [
  ["path", { d: "M16.75 16V14.75C16.75 13.7835 17.5335 13 18.5 13C18.9768 13 19.4091 13.1907 19.7247 13.5M15 16V21H22V16H15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderUnlockedIcon;
